/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-loss-of-precision */
import { useMapEvent } from 'react-leaflet';
import MapControlButtons from 'components/widgets/map/MapControlButtons';
import React, { Fragment, Suspense, useEffect, useMemo, useState } from 'react';
import { MapContainer, Polyline, TileLayer } from 'react-leaflet';
import { useDispatch, useSelector } from 'react-redux';
import { mapSlice, mapTooltipModalState, mapZoomState, updateTooltipModal } from 'redux/slices/mapSlice';
import { IMap, ITooltipModal } from 'types/interfaces';
import PlanUtils from 'utils/PlanUtils';
import { defaultLocation, enviroments, /* RUTAS_GENERALES_MUL2 */ } from 'utils/constants';
import LeafletMaker from './LeafletMaker';
import LeafletMap from './LeafletMap';
import { useLanguage } from 'context/languageContext';
import { useLocation } from 'react-router-dom';
import UserLocation from './UserLocation';
import { mapOnClickState } from 'redux/slices/mapSlice';
import {
  selectedLineDirectionState,
  updateSelectedLineDirection,
  directionsState,
} from 'redux/slices/linesSlice';
import { RUTAS_GENERALES_MUL2 } from 'utils/constants';
import 'resources/styles/components/widgets/map.scss';
import { useNominatim } from 'hooks/useNominatim/useNominatim';
import L from 'leaflet';

export default function MapLeafletContainer(props: IMap) {
  const currentLanguage = useLanguage();
  const location = useLocation();
  const dispatch = useDispatch();
  const selectorMapZoom = useSelector(mapZoomState);
  const selectedDirectionSelector = useSelector(selectedLineDirectionState);
  const showTooltipOverlapping = useSelector(mapTooltipModalState);
  const onMapClick = useSelector(mapOnClickState);
  const setShowTooltipOverlapping = (value: ITooltipModal | undefined) => dispatch(updateTooltipModal(value));
  const selectorDirections = useSelector(directionsState);
  const [dashOffset, setDashOffset] = useState(0);
  const { getNominatimReverse } = useNominatim();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
      const m = L.DomUtil.get('map') as (HTMLElement & { _leaflet_id: number | null }) | null;
      if (m) {
        m._leaflet_id = null;
      }
    };
  }, []);

  const handleMapDoubleClick = (e)=> {
    const CURRENT_ROUTE = `/${location.pathname.split('/')[2]}`;
    /* PASO POR PARADA */
    if (String(`${CURRENT_ROUTE}/`).includes(`/${RUTAS_GENERALES_MUL2.paradas[currentLanguage]}`)) {
      getNominatimReverse({lat:e.latlng.lat, lng:e.latlng.lng});
    }
  };

  // NOMINATIM reverse
  const MapDoubleClickHandler = ()=> {
    useMapEvent('dblclick', (e) => {
      handleMapDoubleClick(e);
    });
    return null; // Este componente no renderiza nada
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setDashOffset((prev) => {
        const newOffset = (prev + 1) % 20; // Actualizamos el offset de la línea
        return newOffset; // Retorna el nuevo valor actualizado
      });
    }, 200); // Cada 100ms actualizamos el offset

    return () => clearInterval(interval); // Limpiar el intervalo cuando el componente se desmonta
  }, [props.polylines]); // No pasamos `dashOffset` como dependencia aquí porque usamos `prev` dentro de `setDashOffset`

  const markers = useMemo(() => {
    return (
      props.markers &&
      props.markers.length > 0 &&
      props.markers.map((marker, i) => {
        return (
          <Fragment key={`leafetMarker_ ${marker.id}_${selectorMapZoom}_${i}`}>
            <LeafletMaker
              id={marker.id}
              position={marker.position}
              content={marker.content}
              onClick={marker.onClick}
              selected={marker.selected}
              popUp={marker.popUp}
              popUpElement={marker.popUpElement}
              background={marker.background}
              iconId={marker.iconId}
              iconAnchor={marker?.adjustIcon}
            />
          </Fragment>
        );
      })
    );
  }, [props.markers, currentLanguage, selectorMapZoom]);

  const calcularMaxMinCoordenadas = (array) => {
    // Inicializamos arrays para almacenar los valores de X y Y
    let allX: any = [];
    let allY: any = [];

    // Recorremos el array para extraer todos los valores X y Y
    array.forEach((subArray) => {
      subArray.forEach((pair) => {
        allX.push(parseFloat(pair[0])); // Convertimos a número y añadimos a X
        allY.push(parseFloat(pair[1])); // Convertimos a número y añadimos a Y
      });
    });

    // Calculamos el máximo y mínimo de X y Y
    const maxX = Math.max(...allX);
    const minX = Math.min(...allX);
    const maxY = Math.max(...allY);
    const minY = Math.min(...allY);

    // El resultado final
    return [
      [maxX, maxY],
      [minX, minY],
    ];
  };

  const changeDirection = ()=> {
    const newdirection = selectorDirections.find((dir) => dir.tripId !== selectedDirectionSelector.tripId);
    dispatch(updateSelectedLineDirection(newdirection));
  };

  const polylines = useMemo(() => {
    var totalCoordinates: any = [];
    var result: any;
    if (props.polylines && props.polylines.length) {
      const polylinesOrdered = [...props.polylines]?.sort((a, b) => {
        return a.selected === b.selected ? 0 : a.selected ? 1 : -1;
      });
        result = polylinesOrdered.map((polyline) => {
          const pathOptions = {
            color: polyline['color'] || '#008472',
            fillColor: 'white',
            fillOpacity: 1,
            weight: polyline['weight'] || 4,
            smoothFactor:1,
            zIndex: 5,
          };

          if (polyline['selected']) {
            const pathOptionsdisc = {
              color: '#FFFFFF',
              fillColor: 'white',
              fillOpacity: 1,
              weight: 4,
              zIndex: 2,
              dashArray: '5, 15',
              dashOffset: dashOffset + 'px',
              smoothFactor:1,
            };
            totalCoordinates.push(polyline.positions);
            return (
              polylinesOrdered && (
                <Fragment key={JSON.stringify(polyline)}>
                  <Polyline pathOptions={{ ...pathOptions }} positions={polyline.positions} />{' '}
                  <Polyline pathOptions={pathOptionsdisc} positions={polyline.positions} />
                </Fragment>
              )
            );
          } else {
            return (
              polylinesOrdered && (
              <Fragment key={JSON.stringify(polyline)}>
                  <Polyline
                    eventHandlers={{
                      click: (e) => {
                        polyline?.lines &&
                          polyline?.lines?.length &&
                          setShowTooltipOverlapping({
                            latitude: e?.latlng?.lat,
                            longitude: e?.latlng?.lng,
                            lines: polyline?.lines,
                          });
                          changeDirection();
                      },
                    }}
                    pathOptions={pathOptions}
                    positions={polyline.positions}
                    key={JSON.stringify(polyline)}
                  />
                </Fragment>
              )
            );
          }
        });
      // }
      const maxmin = calcularMaxMinCoordenadas(totalCoordinates);
      dispatch(
        mapSlice.actions.flyTo({
          coords: PlanUtils.getMidPoint(
            { longitude: maxmin[1][1], latitude: maxmin[1][0] },
            { longitude: maxmin[0][1], latitude: maxmin[0][0] },
          ),
          zoom: PlanUtils.getMidZoom(
            { longitude: maxmin[1][1], latitude: maxmin[1][0] },
            { longitude: maxmin[0][1], latitude: maxmin[0][0] },
          ),
        }),
      );
      return result;
    } else {
      return <></>;
    }
  }, [props.polylines]);

  return (
      <div className='map' /* id='map' */ key={window?.location?.pathname?.split('/')[2]}>
        <MapControlButtons setMapInstance={props.setMapInstance} focus={props.focus} />
        {isMounted ? <MapContainer
          key={window?.location?.pathname?.split('/')[2]}
          attributionControl={false}
          center={
            JSON.parse(localStorage.getItem('mapData') as string)?.coords ?? [
              defaultLocation?.lat,
              defaultLocation?.lng,
            ]
          }
          minZoom={12}
          style={{ flex: 1, zIndex: '4' }}
          zoom={JSON.parse(localStorage.getItem('mapData') as string)?.zoom ?? selectorMapZoom}
          preferCanvas={true}
          zoomControl={false}
          maxBounds={[
            [39.748144 /* arriba */, 2.553058 /* izquierda */],
            [39.472432 /* abajo */, 2.830136 /* derecha */],
          ]}
          scrollWheelZoom={true}
          maxZoom={18}
        >
          <Suspense fallback={<></>}>
              <MapDoubleClickHandler /> {/* Evento doble click solo en paso por parada */}

              <TileLayer url={`${enviroments.endPoint}/tiles/{z}/{x}/{y}.png`} />
              <>{markers}</>

              <LeafletMap /* dblclick={(e) => handleMapDoubleClick(e)} */ onClick={() => {showTooltipOverlapping && setShowTooltipOverlapping(undefined);onMapClick && onMapClick();}} />
              <>{polylines}</>
              <>{props.genericElements.map((element) => element)}</>

              <UserLocation />
          </Suspense>
        </MapContainer> : null}
      </div>
  );
}
